"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDispatchToPropsMortgage = void 0;
var format_1 = require("@/utils/format");
var myokay_donut_1 = require("@okay/myokay-donut");
var React = require("react");
var react_redux_1 = require("react-redux");
var DetailAction_1 = require("@/pages/detail/actions/DetailAction");
var MortgageSagaCall_1 = require("@/pages/detail/sagas/MortgageSagaCall");
var SfilterPriceGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterPriceGroup");
var MortgageCommon_1 = require("@/pages/mortagage/components/MortgageCommon");
var InputNumber_1 = require("@/components/InputNumber");
var mapDispatchToProps = function (dispatch) { return ({
    onPriceChange: function (value, reload) {
        if (reload === void 0) { reload = true; }
        return dispatch(DetailAction_1.default.onPriceChange(value, reload));
    },
    onDownPaymentChange: function (value, reload) {
        if (reload === void 0) { reload = true; }
        return dispatch(DetailAction_1.default.onDownPaymentChange(value, reload));
    },
    onDurationChange: function (value, reload) {
        if (reload === void 0) { reload = true; }
        return dispatch(DetailAction_1.default.onDurationChange(value, reload));
    },
    onBsdChange: function (value, reload) {
        if (reload === void 0) { reload = true; }
        return dispatch(DetailAction_1.default.onBsdChange(value, reload));
    },
    onAvdChange: function (value, reload) {
        if (reload === void 0) { reload = true; }
        return dispatch(DetailAction_1.default.onAvdChange(value, reload));
    },
    onHasTransactedRecentlyChanged: function (value, reload) {
        if (reload === void 0) { reload = true; }
        return dispatch(DetailAction_1.default.onHasTransactedRecentlyChanged(value, reload));
    },
    onHasTransactedRecentlyMonthChanged: function (value, reload) {
        if (reload === void 0) { reload = true; }
        return dispatch(DetailAction_1.default.onHasTransactedRecentlyMonthChanged(value, reload));
    },
    onInterestRateChange: function (value, reload) {
        if (reload === void 0) { reload = true; }
        return dispatch(DetailAction_1.default.onInterestRateChange(value, reload));
    },
    onCalculateClick: function () { return dispatch(DetailAction_1.default.onCalculateClick()); },
    onCustomizeClick: function () { return dispatch(DetailAction_1.default.onCustomizeClick()); },
    onExpandClick: function (state) {
        return dispatch(DetailAction_1.default.onExpandClick(state));
    },
    onDonutHover: function (item, index) {
        return dispatch(DetailAction_1.default.onDonutHover(item, index));
    },
}); };
exports.mapDispatchToPropsMortgage = mapDispatchToProps;
var mapStateToProps = function (state) { return (__assign(__assign({}, state.detail.mortgage), { t: state.detail.t, tMortgage: state.detail.tMortgage, symbol: state.layout.currencies.options.find(function (it) { return it.key === SfilterPriceGroup_1.SfilterCurrency.HKD; }).symbol, lang: state.layout.language.languages.find(function (it) { return it.id === state.layout.language.current; }).code1 })); };
var mortgage = function (props) {
    var breakdown = MortgageSagaCall_1.getBreakdown(props.t, props).map(function (it, i) {
        return __assign(__assign({}, it), { valueText: format_1.default.currency(Math.ceil(it.value)), active: props.activeIndex === i });
    });
    var donutState = {
        items: breakdown,
        value: format_1.default.currencySale(format_1.default.significantFigureFour(props.totalExpense), props.lang, ''),
        unit: props.symbol,
        caption: props.t.totalExpense,
    };
    var onDurationChange = function (e) {
        return props.onDurationChange(12 * parseInt(e.currentTarget.value.replace(/,/g, ''), 10));
    };
    var onInterestRateChange = function (e) {
        return props.onInterestRateChange(Number(e.currentTarget.value));
    };
    var onBsdChange = function (e) {
        return props.onBsdChange(!e.currentTarget.checked);
    };
    var onAvdChange = function (e) {
        return props.onAvdChange(e.currentTarget.checked);
    };
    var onCustomizeClick = function () { return props.onCustomizeClick(); };
    var onDonutHover = function (item, index) { return props.onDonutHover(item, index); };
    var isStampDutyVisible = props.hasExtraStampDuty;
    var renderStampdutyCheckbox = function () {
        return (React.createElement("div", null, isStampDutyVisible && (React.createElement("div", { className: "c-forms__row l-pad-top" },
            React.createElement("div", { className: "c-forms__cols" },
                React.createElement("div", { className: "c-forms__col" },
                    React.createElement("div", { className: "c-forms__checkboxs" },
                        React.createElement("div", { className: "c-forms__checkbox" },
                            React.createElement("input", { id: "bsd", onChange: onBsdChange, type: "checkbox", checked: !props.buyerStampDuty }),
                            React.createElement("label", { htmlFor: "bsd" }, props.t.hkBuyer)),
                        React.createElement("div", { className: "c-forms__checkbox" },
                            React.createElement("input", { id: "avd", onChange: onAvdChange, type: "checkbox", checked: props.adValoremStampDuty }),
                            React.createElement("label", { htmlFor: "avd" }, props.t.ownsProperty)))))))));
    };
    return (React.createElement("div", { className: "c-mortgage" },
        React.createElement("div", { className: "c-mortgage__container" },
            React.createElement("div", { className: "c-mortgage__input" },
                React.createElement("div", { className: "c-mortgage__filters" },
                    React.createElement("div", { className: "c-forms" },
                        React.createElement("div", { className: "c-forms__row" },
                            React.createElement("div", { className: "c-forms__title" }, props.t.propertyValue),
                            React.createElement("div", { className: "c-forms__cols" },
                                React.createElement("div", { className: "c-forms__col" },
                                    React.createElement("div", { className: "c-forms__fields" },
                                        React.createElement("div", { className: "c-forms__field c-forms__field--addon" }, props.t.hkd),
                                        React.createElement("div", { className: "c-forms__field" },
                                            React.createElement(InputNumber_1.default, { className: "c-forms__input", value: props.price, placeholder: props.t.principlePlaceholder, onValueChanged: props.onPriceChange })))))),
                        React.createElement("div", { className: "c-forms__row" },
                            React.createElement("div", { className: "c-forms__title" }, props.t.downPayment),
                            React.createElement("div", { className: "c-forms__cols" },
                                React.createElement("div", { className: "c-forms__col" },
                                    React.createElement("div", { className: "c-forms__fields" },
                                        React.createElement("div", { className: "c-forms__field c-forms__field--addon" }, props.t.hkd),
                                        React.createElement("div", { className: "c-forms__field" },
                                            React.createElement(InputNumber_1.default, { className: "c-forms__input", value: props.downPayment, placeholder: props.t.downPaymentPlaceholder, onValueChanged: props.onDownPaymentChange })))))),
                        React.createElement("div", { className: "c-forms__row" },
                            React.createElement("div", { className: "c-forms__title" }, props.t.duration),
                            React.createElement("div", { className: "c-forms__cols" },
                                React.createElement("div", { className: "c-forms__col c-forms__col" },
                                    React.createElement("div", { className: "c-forms__fields" },
                                        React.createElement("div", { className: "c-forms__field" },
                                            React.createElement(InputNumber_1.default, { className: "c-forms__input", maxValue: 40, value: props.durationInMonth / 12, placeholder: props.t.durationPlaceholder, onValueChanged: function (value) { return props.onDurationChange(value * 12); } })),
                                        React.createElement("div", { className: "c-forms__field c-forms__field--addon" }, props.t.years))))),
                        React.createElement("div", { className: "c-forms__row" },
                            React.createElement("div", { className: "c-forms__title" }, props.t.interestRate),
                            React.createElement("div", { className: "c-forms__cols" },
                                React.createElement("div", { className: "c-forms__col c-forms__col" },
                                    React.createElement("div", { className: "c-forms__fields" },
                                        React.createElement("div", { className: "c-forms__field" },
                                            React.createElement(InputNumber_1.default, { className: "c-forms__input", value: props.interestRate, placeholder: props.t.interestPlaceholder, onValueChanged: props.onInterestRateChange })),
                                        React.createElement("div", { className: "c-forms__field c-forms__field--addon" }, "%"))))),
                        renderStampdutyCheckbox()),
                    React.createElement("ul", { className: "c-mortgage__disclaimer" },
                        React.createElement("li", null, props.t.mortgageDisclaimer)),
                    React.createElement("div", { className: "c-mortgage__actions" },
                        React.createElement("a", { className: "o-btn o-btn--flat", onClick: onCustomizeClick }, props.t.customizeCalculation)))),
            React.createElement("div", { className: "c-mortgage__result" },
                props.error ? MortgageCommon_1.renderError(props.error, props.tMortgage) : null,
                React.createElement("div", { className: "c-mortgage__columns" },
                    React.createElement("div", { className: "c-mortgage__column c-mortgage__column--chart" },
                        React.createElement("div", { className: "c-mortgage__total" },
                            React.createElement("div", { onClick: onCustomizeClick, className: "c-mortgage__chart" },
                                React.createElement(myokay_donut_1.Donut, __assign({}, donutState, { onHover: onDonutHover }))))),
                    React.createElement("div", { className: "c-mortgage__column  c-mortgage__column--payment" },
                        React.createElement("div", { className: "c-mortgage__rows" },
                            React.createElement("div", { className: "c-mortgage__row" },
                                React.createElement("div", { className: "c-mortgage__monthly" },
                                    React.createElement("div", { className: "c-mortgage__title" }, props.t.monthlyPayment),
                                    React.createElement("div", { className: "c-mortgage__payment" },
                                        React.createElement("span", { className: "c-mortgage__amount" }, format_1.default.currencyDetailLease(Math.ceil(props.paymentPerMonth), props.lang, props.symbol))))),
                            React.createElement("div", { className: "c-mortgage__row" },
                                React.createElement("div", { className: "c-mortgage__monthly" },
                                    React.createElement("div", { className: "c-mortgage__title" }, props.t.totalCashOutlay),
                                    React.createElement("div", { className: "c-mortgage__payment" },
                                        React.createElement("span", { className: "c-mortgage__amount" }, format_1.default.currencyDetailSale(Math.ceil(props.initialCashOutlay), props.lang, props.symbol))))))))))));
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(mortgage);
